import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from "@app/models/util/paginacao";

import { OrgaoDoJudiciario } from '@app/models/orgao-do-judiciario.model';
import { OrgaoDoJudiciarioService } from '@app/services/orgao-do-juriciario.service';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-orgao-do-judiciario-lista',
  templateUrl: './orgao-do-judiciario-lista.component.html'
})
export class OrgaoDoJudiciarioListaComponent implements OnInit {

  bsModalRef: BsModalRef;
  paginacao: Paginacao = new Paginacao();
  filtroDescricao: string = "";

  lstOrgaosDoJudiciario: OrgaoDoJudiciario[];

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private orgaosDoJudiciarioService: OrgaoDoJudiciarioService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.orgaosDoJudiciarioService.obterLista(descricao, pagina).toPromise().then(data => {
      this.lstOrgaosDoJudiciario = data.Dados,
        this.paginacao.totalDeItens = data.Total
    }, erro => {
      //this.loading = false;
      this.toastr.warning("Realize a pesquisa novamente.")
    });
  }

  deletar(orgaosDoJudiciario: OrgaoDoJudiciario) {

    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir o órgão do judiciário: " + orgaosDoJudiciario.Nome + "?";
    this.bsModalRef.content.confirmar = () => {
      this.orgaosDoJudiciarioService.deletar(orgaosDoJudiciario.Id).toPromise().then(
        () => {
          this.obterTodos(this.filtroDescricao, 1);
          this.paginacao.paginaAtual = 1;
        });
    }

  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }
}
